import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { CartMetadata } from 'src/common/interfaces/dtos/ICartMetadata';
import IRecallOrderState from '../../interfaces/states/IRecallOrderState';

const initialState: IRecallOrderState = {
  recallOrderData: [],
};

class RecallOrderReducer extends ImmerReducer<IRecallOrderState> {
  public setRecallOrderData(data: CartMetadata[]): void {
    this.draftState.recallOrderData = data;
  }

  public resetState(): void {
    this.draftState = initialState;
  }
}

export const RecallOrderActions = createActionCreators(RecallOrderReducer);
export const RecallOrderReducerFunction = createReducerFunction(RecallOrderReducer, initialState);
